import { z } from "zod";

/** Типы объектов для формы заявки — единый источник для схемы и селекта. */
export const leadObjectTypes = [
  "Квартира",
  "Дом",
  "Офис",
  "Отель",
  "Ритейл",
  "Музей",
  "Другое",
] as const;

/**
 * Схема заявки на съёмку.
 * Телефон — российский формат, допускает пробелы, дефисы и скобки.
 * Email и комментарий необязательны: пустая строка считается «не заполнено».
 */
export const leadFormSchema = z.object({
  name: z.string().trim().min(2, "Укажите имя").max(80),
  phone: z
    .string()
    .trim()
    .regex(/^(\+?7|8)[\s\-()]*(\d[\s\-()]*){10}$/, "Формат: +7 999 123-45-67"),
  email: z
    .union([z.literal(""), z.string().email("Проверьте email")])
    .optional(),
  objectType: z.enum(leadObjectTypes),
  message: z.string().trim().max(2000).optional().or(z.literal("")),
  consent: z.literal(true, {
    error: () => "Нужно согласие на обработку данных",
  }),
});

export type LeadFormValues = z.infer<typeof leadFormSchema>;
